import { useEffect, useState } from 'react';
import { getTransitioningSessionStatus } from 'App/Activity/ResourceActionHandler';
import {
	Session,
	UNKNOWN_STATE,
	useResourceManagerContext,
} from 'App/Activity/ResourceManagerContext';
import { getLaunchProgressOperationId } from 'App/Activity/Utility';
import { getLaunchProgressStatus } from 'App/ProgressAlert/utils';
import { LaunchStatus } from 'Environment/launchResource/launchResource';
import { useLoadableResourceContext } from 'Workspace/ResourceProvider';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

export const useTransitioningStatus = (session: Session, resource?: Resource) => {
	const { value: resourceContext } = useLoadableResourceContext();
	const context = useResourceManagerContext();
	const [status, setStatus] = useState<string>(UNKNOWN_STATE);
	useEffect(() => {
		const activeAction =
			context.activeSessionActions.find(
				action => action?.session.sessionId === session?.sessionId
			) ||
			context.activeMachineActions.find(
				action => action?.machine.machineId === session?.machineData?.machineId
			) ||
			context.activeLaunchActions.find(
				action => action?.session.sessionId === session?.sessionId
			);
		if (activeAction) {
			setStatus(getTransitioningSessionStatus(activeAction.action));
		} else if (resource) {
			const operationId = getLaunchProgressOperationId(
				resource.id,
				resourceContext.launchProgress
			);
			/** Ignore the failed status as of now but later it will be handled and status of desktop will be marked as "Troubleshoot"
			 * so that user can troubleshoot the issue from the more actions menu
			 */
			if (resourceContext.launchProgress[operationId]?.status === LaunchStatus.Failed) {
				setStatus(UNKNOWN_STATE);
				return;
			}
			setStatus(
				operationId
					? getLaunchProgressStatus(resourceContext.launchProgress[operationId])
					: UNKNOWN_STATE
			);
		} else {
			setStatus(UNKNOWN_STATE);
		}
	}, [
		context.activeSessionActions,
		context.activeMachineActions,
		session,
		context.activeLaunchActions,
		resource,
		resourceContext.launchProgress,
	]);

	return status;
};
